export default __webpack_public_path__ + "static/media/selfie.4a01fd09.svg";